export default {
      id: "facebook-usage",
      viewBox: "0 0 8 16",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#facebook",
      toString: function () {
        return this.url;
      }
    }